import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const BoothGallery = ({ institutes, onBoothClick, selectedCategory }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
      {institutes?.map((institute) => (
        <div
          key={institute?.id}
          className="group relative bg-white rounded-xl shadow-lg overflow-hidden cursor-pointer transform hover:scale-105 hover:shadow-2xl transition-all duration-300"
          onClick={() => onBoothClick?.(institute?.id)}
        >
          <div className="relative h-48 overflow-hidden">
            <img
              src={institute?.banner}
              alt={institute?.bannerAlt}
              className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
            
            {institute?.liveNow && (
              <div className="absolute top-3 right-3 bg-red-600 text-white px-3 py-1 rounded-full text-xs font-semibold flex items-center gap-1 animate-pulse">
                <div className="w-2 h-2 bg-white rounded-full"></div>
                LIVE NOW
              </div>
            )}

            {institute?.boothType === 'premium' && (
              <div className="absolute top-3 left-3 bg-yellow-500 text-yellow-900 px-3 py-1 rounded-full text-xs font-bold flex items-center gap-1">
                <Icon name="Crown" size={14} color="currentColor" />
                PREMIUM
              </div>
            )}

            {institute?.boothType === 'sponsored' && (
              <div className="absolute top-3 left-3 bg-purple-600 text-white px-3 py-1 rounded-full text-xs font-bold flex items-center gap-1">
                <Icon name="Star" size={14} color="white" />
                SPONSORED
              </div>
            )}

            <div className="absolute bottom-3 left-3 right-3 flex items-center gap-2">
              <div className="w-16 h-16 bg-white rounded-lg p-2 shadow-lg">
                <img
                  src={institute?.logo}
                  alt={institute?.logoAlt}
                  className="w-full h-full object-contain"
                />
              </div>
            </div>
          </div>

          <div className="p-4">
            <h3 className="text-lg font-heading font-bold text-foreground mb-2 line-clamp-2 group-hover:text-primary transition-colors">
              {institute?.name}
            </h3>

            {/* Category tags */}
            {institute?.categories?.length > 0 ? (
              <div className="flex flex-wrap gap-1 mb-3">
                {institute?.categories?.slice(0, 3)?.map((cat) => (
                  <span
                    key={cat}
                    className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium bg-primary/10 text-primary"
                  >
                    <Icon name="Tag" size={10} color="var(--color-primary)" />
                    {cat}
                  </span>
                ))}
                {institute?.categories?.length > 3 && (
                  <span className="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-muted text-muted-foreground">
                    +{institute?.categories?.length - 3}
                  </span>
                )}
              </div>
            ) : (
              <p className="text-sm text-muted-foreground mb-3 flex items-center gap-1">
                <Icon name="Tag" size={14} color="var(--color-muted-foreground)" />
                {institute?.category}
              </p>
            )}

            <div className="flex items-center justify-between">
              <div className="flex items-center gap-1 text-sm text-muted-foreground">
                <Icon name="Users" size={16} color="var(--color-muted-foreground)" />
                <span>{institute?.visitors} visitors</span>
              </div>
              <Button
                variant="ghost"
                size="sm"
                iconName="ArrowRight"
                iconPosition="right"
                className="text-primary hover:bg-primary/10"
              >
                Visit
              </Button>
            </div>
          </div>

          <div className="absolute inset-0 border-4 border-transparent group-hover:border-primary rounded-xl transition-colors pointer-events-none"></div>
        </div>
      ))}
    </div>
  );
};

export default BoothGallery;